import {
  STOCK_TAKING_CAR_MANAGEMENT_GET_CARLOT_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_GET_CARLOT_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_GET_CARLOT_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_TAKING_CAR_MANAGEMENT_GET_CARLOT_BEGIN:
      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
          carLotOptionsPending: true
        }
      }

    case STOCK_TAKING_CAR_MANAGEMENT_GET_CARLOT_SUCCESS:


      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
          carLotOptions: action.data.carLotOptions,
          carLotDefault: action.data.carLotDefault,
          carLotOptionsPending: false
        }
      }
    case STOCK_TAKING_CAR_MANAGEMENT_GET_CARLOT_FAILURE:
      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
          carLotOptionsPending: false,
          error: action.data
        }
      }
    default:
      return state
  }
}
